module.exports = __webpack_public_path__ + "img/rumor-1.a08f9ef4.png";